<template>
  <div v-if="showSupportOptions">
    <div id="support">
      <el-row id="support-container">
        <div id="powered-container">
          <span @click="safetyPage()">
            <img src="@/assets/powered-safety.svg" class="powered-img" />
          </span>
        </div>
        <div id="support-container">
          <el-button type="success" class="support-btn" @click="dialogInstructivo = true">
            <i class="el-icon-tickets" /> {{ $t("Preguntas Frecuentes") }}
          </el-button>
          <el-button type="danger" class="support-btn" @click="dialogManuales = true">
            <i class="el-icon-tickets" /> {{ $t("Manuales") }}
          </el-button>
          <el-button type="primary" class="support-btn" @click="supportVideoVisible = true">
            <i class="el-icon-caret-right" /> {{ $t("Video Tutorial") }}
          </el-button>
          <el-button type="info" class="support-btn" @click="supportFormVisible = true">
            <i class="el-icon-message" /> {{ $t("Escríbenos") }}
          </el-button>
          <el-button type="warning" class="support-btn" @click="supportPhoneVisible = true">
            <i class="el-icon-phone-outline" /> {{ $t("Llámanos") }}
          </el-button>
        </div>
      </el-row>

      <!-- Dialog Manuales -->

      <el-dialog :visible.sync="dialogManuales" :title="$t('¿Necesitas Ayuda?')" width="40%" center>
        <center>
          <a download href="/files/instructivo.pdf">
            <el-button style="width: 100%; font-size: 12px;" plain type="primary" size="small" icon="el-icon-tickets">
              Descargar Instructivo y terminología para campos de medio ambiente</el-button>
          </a>
          <br><br>
          <el-button style="width: 100%; font-size: 12px;" plain type="primary" size="small" icon="el-icon-tickets"
            @click="descargarInstructivo('mel')">Descargar
            Instructivo revisión por tarea (MEL)</el-button>
          <br /><br />
          <el-button style="width: 100%; font-size: 12px;" plain type="primary" size="small" icon="el-icon-tickets"
            @click="descargarInstructivo('spence')">Descargar
            Instructivo revisión por tarea (SPENCE, CERRO COLORADO,
            BHP)</el-button>
          <br /><br />
          <el-button style="width: 100%; font-size: 12px;" plain type="primary" size="small" icon="el-icon-tickets"
            @click="descargarManual()">Descargar Manual de
            Usuario</el-button>
          <br><br>
          <a download href="/files/boletincorreos.pdf">
            <el-button style="width: 100%; font-size: 12px;" plain type="primary" size="small" icon="el-icon-tickets">
              Boletín de uso de cuentas institucionales</el-button>
          </a>
        </center>

        <span slot="footer" class="dialog-footer">
          <el-button type="warning" style="width: 150px;" @click="dialogManuales = false">{{
            $t("Cancelar")
          }}</el-button>
        </span>
      </el-dialog>

      <!--Dialog preguntas-->
      <el-dialog :visible.sync="dialogInstructivo"
        :title="$t('Preguntas frecuentes Plataforma inventario de riesgos HSE online')" width="80%" center top="30px">
        <pdf src="/files/preguntas.pdf"></pdf>
        <span slot="footer" class="dialog-footer">
          <el-button size="large" style="width: 150px;" type="primary" @click="dialogInstructivo = false">{{
            $t("Cancelar")
          }}</el-button>
        </span>
      </el-dialog>

      <!--Dialog teléfono-->
      <el-dialog :visible.sync="supportPhoneVisible" :title="$t('¿Necesitas Ayuda?')" width="30%" center>
        <hr />
        <p class="support-phone-1">+56 9 7499 5325 <br> +56 9 9022 5668</p>
        <hr />
        <p class="support-text">
          También puede comunicarse con nosotros escribiendo directamente a
          <b>support@safetyclub.zendesk.com</b>
        </p>
        <p class="support-text">
          <i>{{
            $t("Horario atención telefónica: Lunes a Viernes de 9:00 a 18:30")
          }}</i>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" style="width: 150px;" @click="supportPhoneVisible = false">Cancelar</el-button>
        </span>
      </el-dialog>

      <!--Dialog correo-->
      <el-dialog title="¿Necesitas Ayuda?" :visible.sync="supportFormVisible" width="30%" center>
        <el-form :model="form" status-icon :rules="rules" ref="form">
          <el-form-item :label="$t('Nombre Completo*')" prop="nombre">
            <el-input v-model="form.nombre"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Correo*')" prop="correo">
            <el-input v-model="form.correo"></el-input>
          </el-form-item>
          <el-form-item type="number" :label="$t('Teléfono')" prop="telefono">
            <el-input v-model="form.telefono">
              <template slot="prepend">+56</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('Tipo de Usuario')">
            <br />
            <el-select v-model="form.role" class="w-100" prop="" :placeholder="$t('Seleccione tipo de usuario')">
              <el-option v-for="(value, key) in bhpProfiles" :key="key" :label="value" :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Mensaje*')" prop="mensaje">
            <el-input type="textarea" v-model="form.mensaje"></el-input>
          </el-form-item>
        </el-form>
        <p class="support-text">
          También puede comunicarse con nosotros escribiendo directamente a
          <b>support@safetyclub.zendesk.com</b> o llamando al <br>
          <b>+56 9 7499 5325</b> / <b>+56 9 9022 5668</b>.
        </p>
        <p class="support-text">
          <i>Horario atención telefónica y chat: Lunes a Viernes de 9:00 a
            18:30</i>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cleanForm">{{ $t("Cancelar") }}</el-button>
          <el-button type="primary" @click="sendMail('form')">{{
            $t("Enviar")
          }}</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="supportVideoVisible">
        <span style="font-size: 21px;"><b>Tutorial Inventario de Riesgos</b></span>
        <br><br>
        <!-- Video Administrador Plataforma -->
        <div v-if="admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Administradores de Plataforma</span></b>
          </p>

          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/j_g5rVHDs04" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>
        <br /><br />
        <!-- Video Revisor -->
        <div v-if="reviewer">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Revisores</span></b>, que son aquellos que su función es analizar y revisar los
            riesgos
            de los inventarios <el-tag class="resaltar" type="warning"
              style="margin-left: 10px; background-color: orange; color: white; font-weight: bold;">Video
              Actualizado</el-tag>
          </p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe v-if="mel()" class="resp-iframe" src="https://www.youtube.com/embed/gsd8FCHoxTg" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
              <iframe v-else class="resp-iframe" src="https://www.youtube.com/embed/Z5YJtBUmPJY" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>
        <br /><br />
        <!-- Video Revisor -->
        <div v-if="reviewer">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Revisores</span></b>, que son aquellos que su función es analizar y revisar los
            riesgos
            de los inventarios <el-tag class="resaltar" type="warning"
              style="margin-left: 10px; background-color: orange; color: white; font-weight: bold;">Video
              Actualizado</el-tag>
          </p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/jSmtVal46eM?si=V-YMf4yd94mu4dU5" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>
        <br /><br />
        <!-- Video Creador o Default -->
        <div v-if="creator || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Coordinadores</span></b>, para realizar la revisión anual de un inventario. <el-tag
              class="resaltar" type="warning"
              style="margin-left: 10px; background-color: orange; color: white; font-weight: bold;">Video
              Actualizado</el-tag>
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/pYqLPPjLeTE?si=62hxWbZu7cu4FPjb"
                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <div v-if="creator || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Coordinadores</span></b>, que son aquellos que su función es crear los
            inventarios <el-tag class="resaltar" type="warning"
              style="margin-left: 10px; background-color: orange; color: white; font-weight: bold;">Video
              Actualizado</el-tag>
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/4st-VMxlbZM" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <div v-if="creator || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Coordinadores</span></b>, para la modificación de riesgos rechazados en la revisión
            del workflow
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/PDt-1YMCid0?si=8jCKFaWdPVpxHiFZ" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <div v-if="creator || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Coordinadores</span></b>, para el cambio de inventario a borrador
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/B28ncjK41qE?si=S_Wybneeaq9xoZy5" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <div v-if="creator || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Coordinadores</span></b>, para crear un riesgo personalizado de Medio
            ambiente<el-tag class="resaltar" type="warning"
              style="margin-left: 10px; background-color: orange; color: white; font-weight: bold;">Video
              Actualizado</el-tag>
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/-zFgGfW2PVw?si=NTggVnGOU8ds209C"
                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <div v-if="creator || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Coordinadores</span></b>, como copiar tareas con riesgos o riesgos individuales de
            un inventario a otro inventario (Coordinador) <el-tag class="resaltar" type="warning"
              style="margin-left: 10px; background-color: orange; color: white; font-weight: bold;">Nuevo Video</el-tag>
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/ed0QkuhmhCY?si=APCc92yePm91NVsX"
                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <div v-if="creator || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Coordinadores</span></b>, como copiar un riesgo o múltiples riesgos de una tarea a
            una nueva tarea en un mismo inventario (Coordinador) <el-tag class="resaltar" type="warning"
              style="margin-left: 10px; background-color: orange; color: white; font-weight: bold;">Nuevo Video</el-tag>
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/2BOjGyvJ5og?si=AZu8jc7Uc5ES_bSd" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <div v-if="$store.getters.role.role === 'environment' || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Especialistas Medioambientales</span></b>, para la validación de los
            inventarios que no poseen riesgos de tipo medioambiental.
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/Ur2HlQLJ-GI" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <!-- Video owner o super -->
        <div v-if="['owner', 'contract_owner', 'super'].includes($store.getters.role.role) || admin">
          <p class="text-tutorial" style="line-height : 35px;">
            El siguiente video corresponde a un tutorial para
            <b><span class="text-bhp">Revisores</span></b>, para validar la revisión anual pendiente en un
            inventario.<el-tag class="resaltar" type="warning"
              style="margin-left: 10px; background-color: orange; color: white; font-weight: bold;">Video
              Actualizado</el-tag>
          </p>
          <p></p>
          <div class="video-cont">
            <div class="resp-container">
              <iframe class="resp-iframe" src="https://www.youtube.com/embed/m1vRl2V-2a0?si=FwaGl5-aMG4hQs5K"
                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen />
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button style="width: 150px;" type="warning" @click="supportVideoVisible = false">{{
            $t("Cancelar")
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import pdf from 'vue-pdf'

const SERVICE_EMAIL_URL = "/usuarios/mailing/soporte";

export default {
  name: "supportFooter",
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
      role: "role",
    }),
  },
  data() {
    const validarNombre = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t("Nombre es obligatorio")));
      }
      callback();
    };
    const validarCorreo = (rule, value, callback) => {
      const re = new RegExp(
        "^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$"
      );
      if (value === "") {
        return callback(new Error(this.$t("Correo es obligatorio")));
      }
      if (!value.match(re)) {
        return callback(new Error(this.$t("Error formato correo")));
      }
      callback();
    };
    const validarTelefono = (rule, value, callback) => {
      const pattern = new RegExp("^\\d{9}$");
      if (value === "" || !value.match(pattern)) {
        return callback(
          new Error(this.$t("Error formato teléfono: 9 números"))
        );
      }
      callback();
    };
    const validarMensaje = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t("Mensaje es obligatorio")));
      }
      callback();
    };
    return {
      dialogInstructivo: false,
      dialogManuales: false,
      showSupportOptions: false,
      supportVideoVisible: false,
      supportFormVisible: false,
      supportPhoneVisible: false,
      sendingEmail: false,
      creator: false,
      reviewer: false,
      admin: false,
      bhpProfiles: {
        hse: "HSE",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("HSE Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente"),
        super: this.$t("Superintendente"),
        general_manager: this.$t("Gerente General"),
      },
      form: {
        nombre: "",
        correo: "",
        telefono: "",
        perfil: "",
        mensaje: "",
      },
      rules: {
        nombre: [{ validator: validarNombre, trigger: "blur" }],
        correo: [{ validator: validarCorreo, trigger: "blur" }],
        telefono: [{ validator: validarTelefono, trigger: "blur" }],
        mensaje: [{ validator: validarMensaje, trigger: "blur" }],
      },
    };
  },
  components: {
    pdf,
  },
  created() {
    if (this.role) {
      if (this.role.admin) {
        this.admin = true;
      }
      if (["coordinator", "contractor_coordinator"].includes(this.role.role)) {
        this.creator = true;
      } else {
        this.reviewer = true;
      }
    }

    // CHAT
    this.setShowSupportOptions();
    // ZendeskChat
    window.zESettings = {
      webWidget: {
        offset: {
          horizontal: "0px",
          vertical: "0px",
        },
        chat: {
          suppress: false,
        },
        talk: {
          suppress: false,
        },
        helpCenter: {
          suppress: false,
        },
        contactForm: {
          suppress: true,
        },
      },
    };
  },
  watch: {
    isLoggedIn() {
      this.setShowSupportOptions();
    },
    showSupportOptions() {
      if (window.zE) {
        this.showSupportOptions ? window.zE.show() : window.zE.hide();
      } else if (this.showSupportOptions) {
        // Start of safetyclub Zendesk Widget script
        window.zE ||
          (function (e, t, s) {
            var n =
              (window.zE =
                window.zEmbed =
                function () {
                  n._.push(arguments);
                });
            const a = (n.s = e.createElement(t));
            const r = e.getElementsByTagName(t)[0];
            n.set = function (e) {
              n.set._.push(e);
            };
            n._ = [];
            n.set._ = [];
            a.async = true;
            a.setAttribute("charset", "utf-8");
            a.src = `https://static.zdassets.com/ekr/asset_composer.js?key=${s}`;
            n.t = +new Date();
            a.type = "text/javascript";
            r.parentNode.insertBefore(a, r);
          })(document, "script", "cd9487bd-3ef3-4a2c-8bcc-1d563414092d");
      }
    },
  },
  methods: {
    descargarManual() {
      window.location.href =
        "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/MAm-HSE-MAN-219%20Manual%20Plataforma%20de%20Inventario%20de%20Riesgos%20HSE%20firmado.pdf?inline=false";
    },
    descargarInstructivo(faena) {
      if (faena === "mel") {
        window.location.href = "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/Instructivo%20nueva%20funci%C3%B3n%20_Revision%20por%20tarea%20MEL_.pdf?inline=false";
      } else {
        window.location.href = "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/Instructivo%20nueva%20funci%C3%B3n%20_Revisi%C3%B3n%20por%20tarea%20Pampa%20Norte_.pdf?inline=false";
      }
    },
    mel() {
      return this.$store.getters.role.faena_id === '5a6f78337b772dcfe68241d5';
    },
    setShowSupportOptions() {
      this.showSupportOptions = this.isLoggedIn;
    },
    sendMail(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendingEmail = true;

          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          axios
            .post(SERVICE_EMAIL_URL, { form: this.form }, config)
            .then((response) => {
              this.sendingEmail = false;
              this.$alert(
                this.$t("Correo enviado exitosamente."),
                this.$t("Proceso exitoso"),
                {
                  type: "success",
                }
              );
              this.cleanForm();
            })
            .catch((error) => {
              this.sendingEmail = false;
              console.error(error);
              this.$alert(
                this.$t(
                  "Lo sentimos, ha surgido un error. Intente nuevamente."
                ),
                this.$t("Atención"),
                {
                  type: "error",
                }
              );
            });
        } else {
          console.log("formulario no válido");
          return false;
        }
      });
    },
    cleanForm() {
      this.form.nombre = "";
      this.form.correo = "";
      this.form.telefono = "";
      this.form.role = "";
      this.form.mensaje = "";

      this.supportFormVisible = false;
    },
  },
};
</script>

<style scoped>
#support {
  margin-top: 80px;
}

#Embed {
  display: none;
}

#support-container {
  position: fixed;
  bottom: 10px;
  right: 170px;
  z-index: 999;
}

#powered-container {
  position: fixed;
  bottom: 10px;
  left: 150px;
  z-index: 999;
}

[class*=" el-icon-"],
[class^="el-icon-"] {
  font-weight: bold;
}

.el-button {
  letter-spacing: 0.6;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 15px;
}

.support-btn {
  height: 47px;
  border-radius: 999rem;
}

.support-text {
  text-align: center;
}

.support-phone-1 {
  text-align: center;
  font-size: 3em;
}

.support-phone-2 {
  text-align: center;
  font-size: 2em;
}

.powered-img {
  height: 16px;
}

.text-tutorial {
  font-size: 18px;
  color: black;
}

.resaltar {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {

  0%,
  100% {
    box-shadow: 0px 0px 20px #ed7d31;
  }

  50% {
    box-shadow: 0px 0px 0px #ed7d31;
  }
}
</style>
